const module = {
  firestorePath: 'recommendationBusiness',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'recommendationBusiness',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      status: '',
      titleId: '',
      titleEn: '',
      subtitleId: '',
      subtitleEn: '',
      itemList: []
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => Object.values(state.data)
  },
  mutations: {},
  actions: {},
}

export default module
